import { isActionFromViewer } from "./isActionFromViewer";

export function ReopenedViewedByHost({ viewerRole, message }) {
  const didHostReopen = isActionFromViewer(message, viewerRole);

  return didHostReopen
    ? "Enquiry re-opened"
    : "The organiser has re-opened the enquiry";
}

export function ReopenedViewedByOrganiser({ viewerRole, message }) {
  const didOrganiserReopen = isActionFromViewer(message, viewerRole);

  return didOrganiserReopen
    ? "Enquiry re-opened"
    : "The host has re-opened the enquiry";
}
